import React, {useEffect, useState, useContext} from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { DataContext } from "contexts/DataContext";
import 'i18n/config';
import { useTranslation } from "react-i18next";
import { setApprove } from "./api";
import { Tooltip } from "@mui/material";

interface AssessmentControlProps {
    control: any;
    selectControl: (control: string) => void;
    formRef: React.RefObject<HTMLFormElement>;
    handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
    categories: any;
    setReloadNavigator?: (reload: boolean) => void;
}
const SubcategoryApproval = (props: AssessmentControlProps) => {
    const { t } = useTranslation();
    const dataContext = useContext(DataContext);
    const [categories, setCategories] = useState([] as any);

    useEffect(() => {
        setCategories(props.categories);
    }, [props.categories]);

    return (
        <>
        {props.control?.id_control && 
        <Box display={'flex'} flexDirection={'column'} justifyContent={'space-around'} height={'100%'}>
            <Box sx={{margin:1}}>
            <Typography variant="controlTitle">
                {props.control?.category_description}
            </Typography>
            </Box>

            <Box sx={{fontSize:14, textAlign:'center'}}>
            <Grid container spacing={1}>
                    <Grid item xs={6}>
                        
                    </Grid>
                    <Grid item xs={2}>
                       <Typography sx={{fontWeight:600, textTransform:'uppercase', fontSize:12}}>{t('Coverage')}</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography sx={{fontWeight:600, textTransform:'uppercase', fontSize:12}}>{t('Maturity')}</Typography>
                    </Grid> 
                    <Grid item xs={2}>
                        <Typography sx={{fontWeight:600, textTransform:'uppercase', fontSize:12}}>{t('Approve')}</Typography>
                    </Grid>
                </Grid>
                {categories.subcategories && categories.subcategories[props.control?.id_category].map((subcategory: any, index: number) => {
                return (
                <Box key={index}>
                <Grid container spacing={1}>
                    <Grid item xs={1} sx={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                        {categories.completed.subcategories[subcategory.id_subcategory] && <CheckCircle />}
                    </Grid>
                    <Grid item xs={5} sx={{textAlign:'left'}}>
                        <Box sx={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
                            <Typography variant="controlText" sx={{fontSize:14}}>
                                {subcategory.subcategory_fncs}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={2} sx={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                        {subcategory.coverage}
                    </Grid>
                    <Grid item xs={2} sx={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                        {subcategory.maturity}
                    </Grid> 
                    <Grid item xs={2} sx={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                        {categories.completed.subcategories[subcategory.id_subcategory] &&
                        <>
                        {subcategory.owner_id === dataContext.user.id ?
                        <Checkbox
                            checked={subcategory.approved ? true : false}
                            disabled={subcategory.owner_id !== dataContext.user.id ? true : false}
                            onChange={async (event) => {
                                await setApprove(dataContext.currentAssessment, subcategory.id_subcategory, event.target.checked);
                                props.setReloadNavigator && props.setReloadNavigator(true);
                            }}
                            />:
                            <Tooltip title={t('Only the owner can approve')}>
                                <span>
                                <Checkbox
                                    checked={subcategory.approved ? true : false}
                                    disabled={true}
                                />
                                </span>
                            </Tooltip>}
                        </>}
                    </Grid>
                </Grid>
                <Divider sx={{margin:1}} />
                </Box>
                )
                })
            }
            </Box>



        </Box>}
        </>
    );
    };

export default SubcategoryApproval;